import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { TextHelperService } from '../../services/text-helper.service';
import { ChartType } from 'chart.js';

@Component({
  selector: 'app-custom-options',
  templateUrl: './custom-options.component.html',
  styleUrls: ['./custom-options.component.scss'],
})
export class CustomOptionsComponent implements OnInit {
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutColors: any[] = [{ backgroundColor: ['#03BCE4', '#F4A238', '#FFE36A'] }];

  @Input() optionCollection: any[];
  @Input() info: boolean = false;
  @Input() onChange: any;
  @Input() path: string;

  comparitorValue: string;
  isInitialized: boolean = false;

  @Output()
  comparitorChange = new EventEmitter<string>();

  @Input()
  get comparitor() {
    return this.comparitorValue;
  }

  set comparitor(val) {
    if (val || this.comparitorValue) {
      this.comparitorValue = val;
      this.comparitorChange.emit(this.comparitorValue);
      if (this.isInitialized && this.onChange) this.onChange();
    }
  }

  constructor(private modalService: NgbModal, private textHelperService: TextHelperService) {}

  ngOnInit() {
    setTimeout(() => {
      this.isInitialized = true;
    }, 2000);
  }

  swapPronouns = (input) => {
    return this.textHelperService.swapPronouns(input, this.path);
  };

  showModal = (item: any) => {
    const modalRef = this.modalService.open(ModalContentComponent, {
      centered: true,
      windowClass: 'calcModal',
    });
    modalRef.componentInstance.item = item;
    modalRef.componentInstance.path = this.path;
  };

  doughnutValues = (item: any) => {
    return [item.protein, item.carbs, item.fats];
  };
}
